import { ModeBadge } from '@src/entities/ActionPath/ui/components/misc/ModeBadge';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

import { Skeleton } from './components/Skeleton';

export function Header({ actionPath = {}, actionPathId = '', actionPathStatistics = {}, isLoading = false }) {
  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <ErrorHandler location="src/pages/private/ActionPaths/View/layouts/Header/Header.jsx">
      <Grid>
        <Grid.Col css={{ paddingTop: 'var(--abyss-space-lg)' }} span={{ xs: '100%' }}>
          <Heading offset={0}>
            <Layout.Group>
              <div>Action Path: {actionPath?.name}</div>
              <div>
                <ModeBadge actionPath={actionPath} />
              </div>
            </Layout.Group>
          </Heading>
          <Text color="var(--abyss-colors-gray6)">
            Last Updated:{' '}
            <time dateTime={actionPathStatistics?.date} style={{ color: 'black' }}>
              {dayjs(actionPathStatistics?.date).format('dddd, MMMM D, YYYY h:mm A')} CST
            </time>
          </Text>
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
